import apiUtils from '@elab/core/utils/apiUtils';
import HTTPClient from '@elab/core/utils/HTTPClient';

const getApiService = () => `${apiUtils.getBaseUri()}`;

const doNewsletterSubscription = async newsletterSubscriptionDTO => {
    const uri = `${getApiService()}/newsletter`;
    const response = await HTTPClient().postJson(uri, newsletterSubscriptionDTO);
    if (!response.ok) {
        throw new Error(`Unable to subscribe user (${response.status})`);
    }
};

export default {
    doNewsletterSubscription,
};
